import React, {useState} from 'react';
import SelectSvgSelector from './SelectSvgSelector';
import CustomAsyncSelect from '../Select/CustomAsyncSelect';
import {deliveryAPI} from '../../API/api';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';

type Props = {
	token: string;
	fieldName: string;
	resetTrigger?: number; // Add reset trigger prop
};
const OrderCitySelect = ({token, fieldName, resetTrigger}: Props) => {
	const {t} = useTranslation();
	const [value, setValue] = useState({
		label: t('Оберіть місто'),
		value: '',
		city_ref: '',
		regionRef: '',
		regionName: '',
	});
	const {setFieldValue} = useFormikContext();

	// Reset internal state when resetTrigger changes
	React.useEffect(() => {
		if (resetTrigger) {
			setValue({
				label: t('Оберіть місто'),
				value: '',
				city_ref: '',
				regionRef: '',
				regionName: '',
			});
		}
	}, [resetTrigger, t]);
	const loadOptions = async (inputValue: string) => {
		try {
			const cities: any = await deliveryAPI.getCityInNP(
				token ?? '',
				inputValue,
			);
			const options = cities?.data?.data[0]?.Addresses?.map((address: any) => ({
				value: address.Ref,
				label: address.MainDescription,
				city_ref: address.DeliveryCity,
				regionName: address.Area,
			}));
			return [...options];
		} catch (error: any) {
			console.error('Error loading options:', error);
			return [];
		}
	};
	const handleChange = (newValue: any) => {
		setValue({
			label: newValue.label,
			value: newValue.value,
			city_ref: newValue.city_ref,
			regionRef: newValue ?? '',
			regionName: newValue ?? '',
		});
		setFieldValue('city_ref', newValue.city_ref);
		setFieldValue('city_name', newValue.label);
		setFieldValue(fieldName, newValue.label);
	};
	return (
		<div>
			<CustomAsyncSelect
				name={fieldName}
				isClearable={false}
				placeholder={t('Оберіть місто')}
				loadOptions={loadOptions}
				cacheOptions
				defaultOptions={true}
				value={value as any}
				onChange={handleChange as any}
			/>
		</div>
	);
};
export default OrderCitySelect;
